import React from "react";
import AsyncSelect from "react-select/async";
import PartnerReportService from "../../../services/PartnerReportService";
import { intToString } from "../../../utilis/functions";

export default function InputAutoComplete({
    token,
    onChange,
    placeholder,
    name,
    styles,
    isClearable,
    value,
}) {
    const loadOptions = (inputValue, callback) => {
        if (inputValue?.length > 2) {
            PartnerReportService.searchCities(
                token,
                encodeURIComponent(inputValue.trim())
            ).then((res) => {
                let data =
                    res?.data?.length > 0
                        ? [
                              ...res?.data?.map((e, index) => ({
                                  id: index + 1,
                                  name: e?.catalog_city,
                                  count: e?.mapped_hotels,
                              })),
                          ]
                        : [];
                callback(
                    data?.map((result) => {
                        return {
                            value: result?.name,
                            label:
                                result.name +
                                `  (${intToString(result?.count)})`,
                            inputValue: inputValue,
                        };
                    })
                );
            });
        }
    };

    let props = {
        inputId: name + "-input",
        id: name,
        name,
        isClearable: isClearable ?? false,

        menuPlacement: "auto",
        // isMulti: isMulti || false,
        styles: {
            ...styles,
            ...{
                menu: (provided) => ({ ...provided, zIndex: 9999 }),
            },
            ...{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            },
        },
        theme: (theme) => ({
            ...theme,
            colors: {
                ...theme.colors,
                primary25: "#D3D7DB",
                primary: "#D3D7DB",
            },
        }),
        //  isOptionDisabled: isOptionDisabled,
    };
    return (
        <>
            <AsyncSelect
                value={value}
                //cacheOptions
                loadOptions={loadOptions}
                placeholder={placeholder ?? "Select..."}
                onChange={(property, value) => {
                    onChange(property);
                }}
                {...props}
                isMulti
            />
        </>
    );
}
